import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import AvatarWithName from 'reusable/mui/avatar-with-name/AvatarWithName'
import { themeConfig } from '@gap/shared/theme'
import { useShareDocumentDialogStore } from './ShareDocumentDialogStore'

export default observer(function AdvisorAccessPopover() {
   const shareDocumentDialogStore = useShareDocumentDialogStore()

   return <Popover
      open={shareDocumentDialogStore.advisorAccessPopoverIsOpen}
      anchorEl={shareDocumentDialogStore.advisorAccessPopoverAnchorEl}
      onClose={shareDocumentDialogStore.closeAdvisorAccessPopover}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
   >
      <Box sx={{ width: 280, p: 2 }}>
         <Typography variant="body1Bold" sx={{ color: themeConfig.primary[900] }}>Team members</Typography>

         {shareDocumentDialogStore.advisorAccessUsers.map(user => <Box
            key={user.id}
            sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1.5 }}
         >
            <AvatarWithName name={user.name} small />
            <Box sx={{ flex: 1, minWidth: 0 }}>
               <Typography variant="body2" noWrap sx={{ color: themeConfig.primary[900] }}>{user.name}</Typography>
               <Typography variant="caption" noWrap sx={{ display: 'block', color: themeConfig.primary[600] }}>{user.email}</Typography>
            </Box>
         </Box>)}
      </Box>
   </Popover>
})
